<template>
  <h2 class="titleStepForm">Employment Information</h2>
  <div class="row">
    <div class="col-12 mb-3">
      <h4 class="font-size-14">Employment Status</h4>
      <div class="row">
        <div class="col-auto mb-2">
          <label
            for="permanentRd"
            class="mb-0 w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
            :class="{
              'is-invalid':
                v$.form.personal.employStatus.$error,
            }"
          >
            <input
              type="radio"
              v-model="form.personal.employStatus"
              value="permanent"
              class="inputRadioCstm d-none"
              id="permanentRd"
              name="empStat"
              disabled
            /><span class="radioCircleIcon"
              ><i
                class="mdi mdi-circle-outline text-theme font-size-20"
              ></i
              ><i
                class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
              ></i
            ></span>
            <h4
              class="font-size-14 text-dark-custom mb-0 ms-1"
            >
              Permanent
            </h4>
          </label>
          <div
            v-for="(personal, index) in v$.form.personal
              .employStatus.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>
        <div class="col-auto">
          <label
            for="temporaryRd"
            class="w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
            :class="{
              'is-invalid':
                v$.form.personal.employStatus.$error,
            }"
          >
            <input
              type="radio"
              v-model="form.personal.employStatus"
              value="temporary"
              class="inputRadioCstm d-none"
              id="temporaryRd"
              name="empStat"
              disabled
            /><span class="radioCircleIcon"
              ><i
                class="mdi mdi-circle-outline text-theme font-size-20"
              ></i
              ><i
                class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
              ></i
            ></span>
            <h4
              class="font-size-14 text-dark-custom mb-0 ms-1"
            >
              Temporary
            </h4>
          </label>
          <div
            v-for="(personal, index) in v$.form.personal
              .employStatus.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>
        <!-- Optional validation: employStatus -->
        <div class="col-auto">
          <label
            for="contractRd"
            class="w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
            :class="{
              'is-invalid':
                v$.form.personal.employStatus.$error,
            }"
          >
            <input
              type="radio"
              v-model="form.personal.employStatus"
              value="contract"
              class="inputRadioCstm d-none"
              id="contractRd"
              name="empStat"
              disabled
            /><span class="radioCircleIcon"
              ><i
                class="mdi mdi-circle-outline text-theme font-size-20"
              ></i
              ><i
                class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
              ></i
            ></span>
            <h4
              class="font-size-14 text-dark-custom mb-0 ms-1"
            >
              Contract
            </h4>
          </label>
          <div
            v-for="(personal, index) in v$.form.personal
              .employStatus.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>
        <div class="col-auto">
          <label
            for="slfEmplyRd"
            class="w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
            :class="{
              'is-invalid':
                v$.form.personal.employStatus.$error,
            }"
          >
            <input
              type="radio"
              v-model="form.personal.employStatus"
              value="self_employed"
              class="inputRadioCstm d-none"
              id="slfEmplyRd"
              name="empStat"
              disabled
            /><span class="radioCircleIcon"
              ><i
                class="mdi mdi-circle-outline text-theme font-size-20"
              ></i
              ><i
                class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
              ></i
            ></span>
            <h4
              class="font-size-14 text-dark-custom mb-0 ms-1"
            >
              Self-Employed
            </h4>
          </label>
          <div
            v-for="(personal, index) in v$.form.personal
              .employStatus.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>
        <div class="col-auto">
          <label
            for="unemployedRd"
            class="w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
            :class="{
              'is-invalid':
                v$.form.personal.employStatus.$error,
            }"
          >
            <input
              type="radio"
              v-model="form.personal.employStatus"
              value="unemployed"
              class="inputRadioCstm d-none"
              id="unemployedRd"
              name="empStat"
              disabled
            /><span class="radioCircleIcon"
              ><i
                class="mdi mdi-circle-outline text-theme font-size-20"
              ></i
              ><i
                class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
              ></i
            ></span>
            <h4
              class="font-size-14 text-dark-custom mb-0 ms-1"
            >
              Unemployed
            </h4>
          </label>
          <div
            v-for="(personal, index) in v$.form.personal
              .employStatus.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>
        <div class="col-auto">
          <label
            for="retiredRd"
            class="w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
            :class="{
              'is-invalid':
                v$.form.personal.employStatus.$error,
            }"
          >
            <input
              type="radio"
              v-model="form.personal.employStatus"
              value="retired"
              class="inputRadioCstm d-none"
              id="retiredRd"
              name="empStat"
              disabled
            /><span class="radioCircleIcon"
              ><i
                class="mdi mdi-circle-outline text-theme font-size-20"
              ></i
              ><i
                class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
              ></i
            ></span>
            <h4
              class="font-size-14 text-dark-custom mb-0 ms-1"
            >
              Retired
            </h4>
          </label>
          <div
            v-for="(personal, index) in v$.form.personal
              .employStatus.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-6 mb-3">
      <h4 class="font-size-14">Pay Frequency</h4>
      <div class="row">
        <div class="col-auto">
          <label
            for="weekRd"
            class="w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
            :class="{
              'is-invalid':
                v$.form.personal.frequencyStatus.$error,
            }"
          >
            <input
              type="radio"
              v-model="form.personal.frequencyStatus"
              value="weekly"
              class="inputRadioCstm d-none"
              id="weekRd"
              name="pay_freq"
              disabled
            /><span class="radioCircleIcon"
              ><i
                class="mdi mdi-circle-outline text-theme font-size-20"
              ></i
              ><i
                class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
              ></i
            ></span>
            <h4
              class="font-size-14 text-dark-custom mb-0 ms-1"
            >
              Weekly
            </h4>
          </label>
          <div
            v-for="(personal, index) in v$.form.personal
              .frequencyStatus.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>
        <div class="col-auto">
          <label
            for="fortnightRd"
            class="w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
            :class="{
              'is-invalid':
                v$.form.personal.frequencyStatus.$error,
            }"
          >
            <input
              type="radio"
              v-model="form.personal.frequencyStatus"
              value="fortnightly"
              class="inputRadioCstm d-none"
              id="fortnightRd"
              name="pay_freq"
              disabled
            /><span class="radioCircleIcon"
              ><i
                class="mdi mdi-circle-outline text-theme font-size-20"
              ></i
              ><i
                class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
              ></i
            ></span>
            <h4
              class="font-size-14 text-dark-custom mb-0 ms-1"
            >
              Fortnightly
            </h4>
          </label>
          <div
            v-for="(personal, index) in v$.form.personal
              .frequencyStatus.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>
        <div class="col-auto">
          <label
            for="monthRd"
            class="w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
            :class="{
              'is-invalid':
                v$.form.personal.frequencyStatus.$error,
            }"
          >
            <input
              type="radio"
              v-model="form.personal.frequencyStatus"
              value="monthly"
              class="inputRadioCstm d-none"
              id="monthRd"
              name="pay_freq"
              disabled
            /><span class="radioCircleIcon"
              ><i
                class="mdi mdi-circle-outline text-theme font-size-20"
              ></i
              ><i
                class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
              ></i
            ></span>
            <h4
              class="font-size-14 text-dark-custom mb-0 ms-1"
            >
              Monthly
            </h4>
          </label>
          <div
            v-for="(personal, index) in v$.form.personal
              .frequencyStatus.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-6 mb-3">
      <div class="d-block">
        <label class="font-size-14">How Long Employed </label>
        <input
          type="text"
          v-model="form.personal.user_howlong"
          class="form-control"
          placeholder="How Long Employed"
          :class="{
            'is-invalid':
              v$.form.personal.user_howlong.$error,
          }"
          disabled
        />
        <div
          v-for="(personal, index) in v$.form.personal
            .user_howlong.$errors"
          :key="index"
          class="invalid-feedback"
        >
          <span v-if="personal.$message">{{
            personal.$message
          }}</span>
        </div>
      </div>
    </div>
    <div class="col-12 mb-3">
      <h4 class="font-size-14">Average Monthly Income</h4>
      <input
        type="text"
        v-model="form.personal.averageIncm"
        class="form-control"
        placeholder="How Long Employed"
        disabled
      />
      <!-- Optional validation: averageIncm -->
    </div>
    <div class="col-lg-6 mb-3">
      <div class="d-block">
        <label class="font-size-14">Occupation</label>
        <input
          type="text"
          v-model="form.personal.user_occupation"
          class="form-control"
          placeholder="Occupation"
          :class="{
            'is-invalid':
              v$.form.personal.user_occupation.$error,
          }"
          disabled
        />
        <div
          v-for="(personal, index) in v$.form.personal
            .user_occupation.$errors"
          :key="index"
          class="invalid-feedback"
        >
          <span v-if="personal.$message">{{
            personal.$message
          }}</span>
        </div>
      </div>
    </div>
    <div class="col-lg-6 mb-3">
      <div class="d-block">
        <label class="font-size-14">Employer</label>
        <input
          type="text"
          v-model="form.personal.employer"
          class="form-control"
          placeholder="Employer"
          :class="{
            'is-invalid': v$.form.personal.employer.$error,
          }"
          disabled
        />
        <div
          v-for="(personal, index) in v$.form.personal
            .employer.$errors"
          :key="index"
          class="invalid-feedback"
        >
          <span v-if="personal.$message">{{
            personal.$message
          }}</span>
        </div>
      </div>
    </div>
    <div class="col-12 mb-3">
      <div class="d-block">
        <template v-if="isPdf">
        <label class="font-size-14">Employer's Address</label>
        </template>
        <template v-if="!isPdf">
        <label class="font-size-14">Employer Address</label>
        </template>
        <textarea
          type="textarea"
          v-model="form.personal.user_employer"
          class="form-control resize-none"
          rows="3"
          :class="{
            'is-invalid':
              v$.form.personal.user_employer.$error,
          }"
          disabled
          placeholder="Address"
        ></textarea>
        <div
          v-for="(personal, index) in v$.form.personal
            .user_employer.$errors"
          :key="index"
          class="invalid-feedback"
        >
          <span v-if="personal.$message">{{
            personal.$message
          }}</span>
        </div>
      </div>
    </div>
    <div class="col-lg-6 mb-3">
      <div class="d-block">
        <label class="font-size-14">Work Phone No</label>
        <template v-if="isPdf">
        <input
          type="text"
          v-model="form.personal.user_w_phone_no"
          class="form-control"
          placeholder="Work Phone No"
          :class="{
            'is-invalid':
              v$.form.personal.user_w_phone_no.$error,
          }"
          disabled
        />
        </template>
        <template v-if="!isPdf">
        <div class="row">
          <div class="col-4 pe-0">
            <div
              class="single-select2-cstm"
              style="min-width: 96px"
            >
              <Select2
                v-model="form.personal.user_w_phone_nocode"
                :options="countrynameIssuanceOpt"
                disabled
              >
              </Select2>
            </div>
          </div>
          <div class="col-8 ps-0">
            <input
              type="text"
              v-model="form.personal.user_w_phone_no"
              class="form-control"
              placeholder="Work Phone No"
              :class="{
                'is-invalid':
                  v$.form.personal.user_w_phone_no.$error,
              }"
              disabled
            />
          </div>
        </div>
        </template>
        <div
          v-for="(personal, index) in v$.form.personal
            .user_w_phone_no.$errors"
          :key="index"
          class="invalid-feedback"
        >
          <span v-if="personal.$message">{{
            personal.$message
          }}</span>
        </div>
      </div>
    </div>
    <div class="col-lg-6 mb-3">
      <div class="d-block">
        <label class="font-size-14"
          >Ext. <sup>(if any)</sup></label
        >
        <input
          type="number"
          v-model="form.personal.user_phone_no"
          class="form-control"
          placeholder="Ext. (if any)"
          :class="{
            'is-invalid':
              v$.form.personal.user_phone_no.$error,
          }"
          disabled
        />
        <div
          v-for="(personal, index) in v$.form.personal
            .user_phone_no.$errors"
          :key="index"
          class="invalid-feedback"
        >
          <span v-if="personal.$message">{{
            personal.$message
          }}</span>
        </div>
      </div>
    </div>
    <div class="col-12 mb-3">
      <div class="d-block">
        <label class="font-size-14"
          >School
          <sup>(if applicant is a student)</sup></label
        >
        <textarea
          type="textarea"
          v-model="form.personal.user_isstudent"
          class="form-control resize-none"
          rows="3"
          :class="{
            'is-invalid':
              v$.form.personal.user_isstudent.$error,
          }"
          disabled
        ></textarea>
        <div
          v-for="(personal, index) in v$.form.personal
            .user_isstudent.$errors"
          :key="index"
          class="invalid-feedback"
        >
          <span v-if="personal.$message">{{
            personal.$message
          }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Select2 from "vue3-select2-component";
import { bridge } from "../formBridge";

export default {
  name: "ReviewEmployment",
  props: {
    variant: { type: String, default: "review" },
  },
  computed: {
    isPdf() {
      return this.variant === "pdf";
    },
  },
  mixins: [
    bridge({
    state: ["countrynameIssuanceOpt", "form"],
    validate: true,
    }),
  ],
  components: { Select2 },
};
</script>
